import { forwardRef } from "react";
import { omitProps } from "../../shared";
import { getHtmlElementType } from "../../html";
import { useStyledSystem } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerBox(props) {
  const {
    as = DefaultElement,
    children,
    forwardedRef,
    ...rest
  } = omitProps(useStyledSystem(props), ["slot"]);
  const As = getHtmlElementType(as);
  return /*#__PURE__*/_jsx(As, { ...rest,
    ref: forwardedRef,
    children: children
  });
}
InnerBox.defaultElement = DefaultElement;
export const Box = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerBox, { ...props,
  forwardedRef: ref
}));